'use strict';

export default {
  header: {
    title: 'Logo',
  },
};
